module.exports = __webpack_public_path__ + "img/twitter-icon.fd8b9ea.svg";